import React from "react";
import { Link } from "react-router-dom";

const List = ({ children }) => {
    return (
        <div>
            <ul>
                { children }
            </ul>
        </div>
    )
}

const ListItem = ({ text, secondary=" " }) => {
    return (
        <div>
            <li>
                <Link to="#">
                    <span>{ text }</span>
                    <span>{ secondary }</span>
                </Link>
            </li>
        </div>
    )
}


export { List, ListItem };